<template>
  <section id='loginPage'>
    <header>

      <img :src="require('@/assets/img/icon_logo.png')" alt="" class='icon'>
      <ul>
      </ul>


    </header>
    <section class='bgSection'>
      <span class='loginYellow' @click='showSingleOrMore = true'>立即登录</span>
      <img :src="require('@/assets/img/bg@2x.png')" alt="" class='bgImg'>
    </section>

    <p class='info'>聚邻窗红苏州湾大厦党建联盟 All Rights Reserved.</p>

    <Modal v-model="showSingleOrMore" width="500">
      <section class='modalCon'>
        <div class='rightCon' :class='curIndex == 0 ? "act" : ""'>
          <h2>登 录</h2>
          <div class='item'>
            <label for="">用户名</label>
            <input type="text" placeholder="请输入用户名" v-model='username' :class='userempty == 1 ? "active" : ""'>
            <p class='error' v-if='userempty == 1'>请填写用户名</p>
          </div>
          <div class='item'>
            <label for="" class='password'>密码 </label>
            <!-- <label for="" class='password'>密码 <span>忘记密码？</span></label> -->
            <input type="password" placeholder="请输入密码" v-model='password' :class='passempty == 1 ? "active" : ""'>
            <p class='error' v-if='passempty == 1'>请填写密码</p>
          </div>
          <!-- <div class='item' v-if='!inwhiteip'>
            <label for="" class='password'>验证码 </label>
            <div class='btncon'>
              <input type="text" placeholder="请输入验证码" v-model='phonecode' :class='codeempty == 1 ? "active" : ""' />
              <Button type="primary" class='btncode' :size='normalsizwe' @click='getmsg' :loading='isloadcode'>{{
                getCodeNum }}</Button>
            </div>
            <p class='error' v-if='codeempty == 1'>请填写验证码</p>
          </div> -->
          <Checkbox v-model="single" id='remember' color='red'>&nbsp; 记住用户名</Checkbox>
          <Button type="primary" class='loginbtn' long @click='login'>登 录</Button>
          <!-- <Button long @click='curIndex=1'>
						<Icon type="md-qr-scanner" /> 切换为二维码登录
					</Button> -->
        </div>
        <div class='rightCon code' :class='curIndex == 1 ? "act" : ""'>
          <h2>登 录</h2>
          <div id='qrcode'>
            <div class='delay' v-if='isdelay'>
              <span @click='getQRCode()'>刷新二维码</span>
            </div>
            <canvas id="QRCode_header"></canvas>
          </div>
          <p class='codeText'>请使用{{ appname }}界面打开扫一扫</p>
          <Button long style='margin-top:50px' @click='curIndex = 0'>
            <Icon type="md-person" /> 切换为用户名密码登录
          </Button>
        </div>
      </section>
      <div slot='footer'></div>
    </Modal>

  </section>
</template>
<!-- <script src="https://g.alicdn.com/dingding/dingtalk-jsapi/2.13.42/dingtalk.open.js"></script> -->
<script>
import QRCode from 'qrcode'
import utils from '../utils/getSchoolData.js'
export default {
  name: 'login',
  data () {
    return {
      normalsizwe: 'small',
      getCodeNum: '获取验证码',
      targetTime2: new Date().getTime() + 30000,
      phonecode: '123456',
      codeempty: 0,
      showSingleOrMore: false,
      lan: '简体中文（CN）',
      appname: ' ',
      single: false,
      curIndex: 0,
      username: '',
      password: '',
      userempty: 0,
      passempty: 0,
      formValidate: {
        username: '',
        password: '',
      },
      ruleValidate: {
        username: [{
          required: true,
          message: '请填写账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请填写密码',
          trigger: 'blur'
        }],
      },
      ispost: false,
      timer: '',
      djstimer: '',
      isdelay: false,
      rootMenu: [],
      isloadcode: false,
      whitewall: ['58.211.154.178', '221.224.27.26', '121.238.245.165'],
      inwhiteip: false,
      base64: '',
    }
  },
  watch: {
    curIndex: function (newval, oldval) {
      clearInterval(this.timer)
      if (newval == 1) {

        this.getQRCode()
      }
    }
  },
  mounted () {
    this.base64 = require('js-base64').Base64
    var username = localStorage.getItem('jwjcurUsername')
    var password = localStorage.getItem('jwjcurUserpwd')
    var newslist = localStorage.getItem('jwjNews')
    var that = this
    localStorage.clear()
    if (newslist == null || newslist == 'null') {
      localStorage.setItem('jwjNews', [])
    } else {
      localStorage.setItem('jwjNews', newslist)
    }

    if (username && password) {
      this.username = username
      this.password = password
      localStorage.setItem('jwjcurUsername', username)
      localStorage.setItem('jwjcurUserpwd', password)
      this.single = true
    } else {
      this.single = false
    }

    clearInterval(this.timer)
    clearInterval(this.djstimer)
    // this.getIp(function (ip) {
    //   console.log(ip, 'ip')
    //   if (that.whitewall.indexOf(ip) > -1) {
    //     that.inwhiteip = true
    //   }
    // })
    // this.getipSh()
    // this.getLocalIPv4()
    //   .then(ip => console.log(ip))
    //   .catch(error => console.error(error));
    //  this.getLocationByIP()
  },
  methods: {
    getLocationByIP () {
      const ipapiUrl = 'https://ipapi.co/json/';
      var that = this
      // 发起请求获取当前 IP 的地理位置信息
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            const response = JSON.parse(xhr.responseText);

            if (that.whitewall.indexOf(response.ip) > -1) {
              that.inwhiteip = true
            } else {
              that.inwhiteip = false
            }
            console.log('地理位置信息：' + response.city + ', ' + response.country_name);
          } else {
            console.error('IP 定位请求出错：' + xhr.statusText);
          }
        }
      };
      xhr.open('GET', ipapiUrl);
      xhr.send();
    },
    getmsg () {
      var that = this
      that.axios.post('oauth/getWebSms', {
        username: this.username,
        password: this.base64.encode(this.password),
        grant_type: 'password',
        systemid: 'web'
      }).then(back => {

        that.$Message.success(back.msg)
        if (back.success) {
          that.djs()
          that.getCodeNum = '60s'
          that.isloadcode = true
        }
      }).catch(err => {
        console.log(err)
      })

    },
    djs () {
      var timer = 60
      var that = this
      clearInterval(that.djstimer)
      this.djstimer = setInterval(function () {

        if (timer < 2) {
          timer = '获取验证码'
          clearInterval(that.djstimer)
          that.getCodeNum = timer
          that.isloadcode = false
        } else {
          timer -= 1
          that.getCodeNum = timer > 9 ? timer + 's' : '0' + timer + 's'
        }
      }, 1000)
    },
    handleEnd () {
      this.$Message.info('倒计时结束');
    },
    tonewsweb () {

      window.open('https://www.wjdaily.com', '_blank')
    },
    getQRCode () {
      this.isdelay = false
      clearInterval(this.timer)
      var times = 0
      var that = this

      this.axios.get('loginCode/getCode', {
        params: {}
      }).then((res) => {
        let opts = {
          errorCorrectionLevel: "H", //容错级别
          type: "image/png", //生成的二维码类型
          quality: 0.3, //二维码质量
          margin: 3, //二维码留白边距
          width: 160, //宽
          height: 160, //高
          color: {
            dark: "#333333", //前景色
            light: "#fff" //背景色
          }
        };
        this.QRCodeMsg = 'qrlogin_' + String(res.data); //生成的二维码为URL地址js
        let msg = document.getElementById("QRCode_header");
        // 将获取到的数据（val）画到msg（canvas）上
        QRCode.toCanvas(msg, this.QRCodeMsg, opts, function (error) {
          clearInterval(that.timer)
          that.timer = setInterval(function () {
            //console.log(res)
            times += 1
            that.axios.get('loginCode/checkIsLogin', {
              params: {
                code: String(res.data)
              }
            }).then(back => {
              //console.log(back, '----------->')
              if (back && back.success) {
                var _back = back.data


                localStorage.removeItem("inch_tree")

                that.axios.post('oauth/token', {
                  username: back['username'],
                  password: back['pwd'],
                  grant_type: 'password',
                  systemid: 'web'
                }).then(login => {
                  //console.log(login, '---------->')
                  localStorage.setItem('access_token', login[
                    'access_token'])
                  if (login.access_token) {
                    that.$Message.success({
                      content: '登录成功，正在跳转...',
                      duration: 2
                    })
                    that.ispost = false
                    that.reloadLocal()
                    localStorage.setItem('inchUserinfo',
                      JSON.stringify(back.data))
                    localStorage.setItem('inchleftnav',
                      null)
                    localStorage.setItem('inchHeadAct',
                      '0')
                    localStorage.setItem('loadingMenu',
                      false)
                    setTimeout(function () {
                      // that.$router.push('/db')
                    }, 1000)
                  } else {
                    that.$Message.error(login.msg)
                    that.ispost = false
                  }


                })
                clearInterval(that.timer)

              }
              if (times >= 60) {
                clearInterval(that.timer)
                that.isdelay = true
              }
            })
          }, 2000)
        });
      })

    },
    login () {
      var that = this

      if (this.checkVal()) {
        var param = {
          username: this.username,
          password: this.base64.encode(this.password),
          sms_code: this.phonecode
        }
        if (!this.ispost) {
          this.ispost = true
          that.axios.post('oauth/token', {
            username: this.username,
            password: this.base64.encode(this.password),
            sms_code: this.phonecode,
            grant_type: 'password',
            systemid: 'web'
          }).then(back => {

            if (back && back.data && back.data['access_token']) {
              localStorage.setItem('access_token', back.data['access_token'])
              localStorage.setItem('expiresTo', back.data['expires_to'])

              that.axios.post('sys/toLogin', param).then((res, a) => {
                that.getMenu(res.data.guid, function (menus) {
                  if (res.success) {
                    that.$Message.success({
                      content: '登录成功，正在跳转...',
                      duration: 2
                    })
                    that.reloadLocal()
                    that.ispost = false
                    if (that.single) {
                      localStorage.setItem("jwjcurUsername", that.username)
                      localStorage.setItem("jwjcurUserpwd", that.password)
                    } else {
                      localStorage.setItem("jwjcurUsername", '')
                      localStorage.setItem("jwjcurUserpwd", '')

                    }
                    localStorage.setItem('inchUserinfo', JSON.stringify(res.data))
                    localStorage.setItem('inchleftnav', null)
                    localStorage.setItem('inchHeadAct', '0')
                    localStorage.setItem('loadingMenu', false)
                    setTimeout(function () {
                      console.log(menus)
                      that.$router.push(menus[0]['url'])
                    }, 1000)
                  } else {
                    that.$Message.error(res.msg)
                    that.ispost = false
                  }
                })

              })
            } else {
              that.$Message.error(back.msg)

              that.ispost = false
            }

          }).catch(err => {
            console.log(err)
            that.ispost = false
          })
        }
      }
    },
    getipSh () {
      // http://pv.sohu.com/cityjson?ie=utf-8
      // $.ajax({
      //   url: 'http://pv.sohu.com/cityjson?ie=utf-8',
      //   success: function (res) {
      //     console.log(res)
      //   }
      // })

      var RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      if (RTCPeerConnection) (() => {
        var rtc = new RTCPeerConnection()
        rtc.createDataChannel(''); //创建一个可以发送任意数据的数据通道
        rtc.createOffer(offerDesc => { //创建并存储一个sdp数据
          rtc.setLocalDescription(offerDesc)
        }, e => { console.log(e) })
        rtc.onicecandidate = (evt) => { //监听candidate事件

          if (evt.candidate) {
            console.log('evt:', evt.candidate)
            let ip_rule = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
            var ip_addr = ip_rule.exec(evt.candidate.candidate)

            console.log('ip_addr:', ip_addr)   //打印获取的IP地址
          }
        }
      })()
      else { console.log("没有找到") }

      getIntnetIP()
      function jsonpCallback (res) {
        alert(res)
        var ip = res.Ip;    // ip地址
        var aa = res.Isp.split("市");
        var isp = aa[0];    // ip省份
        alert(ip);
      }
      function getIntnetIP () {
        var JSONP = document.createElement("script");
        JSONP.type = "text/javascript";
        JSONP.src = "https://whois.pconline.com.cn/ipJson.jsp?callback=jsonpCallback";
        document.getElementsByTagName("head")[0].appendChild(JSONP);
      }
    },
    getIp (callback) {
      var ip_dups = {};
      var RTCPeerConnection = window.RTCPeerConnection
        || window.mozRTCPeerConnection
        || window.webkitRTCPeerConnection;
      var useWebKit = !!window.webkitRTCPeerConnection;
      var mediaConstraints = {
        optional: [{ RtpDataChannels: true }]
      };
      // 这里就是需要的ICEServer了
      var servers = {
        iceServers: [
          { urls: "stun:stun.services.mozilla.com" },
          { urls: "stun:stun.l.google.com:19302" },
        ]
      };
      var pc = new RTCPeerConnection(servers, mediaConstraints);
      function handleCandidate (candidate) {
        var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
        var hasIp = ip_regex.exec(candidate)

        if (hasIp) {
          var ip_addr = ip_regex.exec(candidate)[1];
          if (ip_dups[ip_addr] === undefined)
            callback(ip_addr);
          ip_dups[ip_addr] = true;
        }
      }
      // 网络协商的过程
      pc.onicecandidate = function (ice) {

        if (ice.candidate) {
          handleCandidate(ice.candidate.candidate);
        }
      };
      pc.createDataChannel("");
      //创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
      pc.createOffer(function (result) {
        pc.setLocalDescription(result, function () { }, function () { });
      }, function () { });
      setTimeout(function () {

        var lines = pc.localDescription.sdp.split('\n');
        lines.forEach(function (line) {
          if (line.indexOf('a=candidate:') === 0)
            handleCandidate(line);
        });
      }, 1000);
    },
    getRootMenu () {
      var that = this

    },
    //   getUserIP (onNewIP) {
    //     //  onNewIp - your listener function for new IPs//compatibility for firefox and chromevar myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;var pc = new myPeerConnection({iceServers: []}),noop = function() {},localIPs = {},ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,key;function iterateIP(ip) {if (!localIPs[ip]) onNewIP(ip);localIPs[ip] = true;}//create a bogus data channelpc.createDataChannel("");// create offer and set local descriptionpc.createOffer().then(function(sdp) {sdp.sdp.split('\n').forEach(function(line) {if (line.indexOf('candidate') < 0) return;line.match(ipRegex).forEach(iterateIP);});pc.setLocalDescription(sdp, noop, noop);}).catch(function(reason) {// An error occurred, so handle the failure to connect});//sten for candidate eventspc.onicecandidate = function(ice) {if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;ice.candidate.candidate.match(ipRegex).forEach(iterateIP);};
    //   }// UsagegetUserIP(function(ip){alert("Got IP! :" + ip);
    // })
    getLocalIPv4 () {
      return new Promise((resolve, reject) => {
        const RTCPeerConnection = window.RTCPeerConnection ||
          window.mozRTCPeerConnection ||
          window.webkitRTCPeerConnection;

        if (!RTCPeerConnection) {
          reject('WebRTC API not available');
          return;
        }

        const pc = new RTCPeerConnection({ iceServers: [] });
        pc.createDataChannel('');

        pc.onicecandidate = function (event) {
          if (event.candidate) {
            const candidateInfo = event.candidate.candidate;
            const localIp = candidateInfo.split(' ')[4];
            if (localIp.includes('.')) {
              resolve(localIp);
              pc.onicecandidate = null;
              pc.close();
            }
          }
        };

        setTimeout(() => {
          reject('Timeout getting local IP address');
          pc.close();
        }, 3000);
      });
    },
    getMenu (id, callBack) {
      var that = this
      //console.log(id,'id')
      that.axios.get('webUser/getId', {
        params: {
          guid: id
        }
      }).then(res => {

        if (res.data.roleIds.length == 0) {
          // that.$Message.info('请配置角色信息')
          utils.getMenuData().then(res => {
            localStorage.setItem('inchheadermenu', JSON.stringify(res))
            that.rootMenu = res

            callBack(res)
          })

          // return false;

        } else {
          that.axios.get('sysRole/getId', {
            params: {
              id: res.data.roleIds[0]
            }
          }).then(res => {
            //console.log(res.data.menuIds,res,'sysRole/menuRole')
            var menuIds = res.data.menuIds
            var selfmenu = []
            that.axios.get('sysMenu/rootMenuJson', {
              params: {}
            }).then((mock) => {
              that.rootMenu = mock.data
              that.rootMenu.map(function (val, index) {
                menuIds.map(function (item, itemidx) {
                  if (val['id'] == item) {
                    selfmenu.push(val)
                  }
                })
              })
              var headmenu = selfmenu.filter(function (val, index) {
                return val['parentId'] == 0
              })


              var secondmenu = that.getSecMenu(selfmenu, headmenu)
              var thirdmenu = that.getThirdMenu(selfmenu, secondmenu)


              headmenu.map(function (v, i) {
                v['children'] = []
                secondmenu.map(function (s, e) {
                  if (v['id'] == s['parentId']) {
                    v['children'].push(s)
                  }
                })
              })
              var newarr = JSON.parse(JSON.stringify(headmenu))
              newarr.map(function (val, index) {
                //console.log(val,'---kkkkkkkk-->')
                val['url'] = val['children'][0]['url']
              })
              that.rootMenu = newarr
              //console.log(newarr,'------->')
              localStorage.setItem('inchheadermenu', null)
              localStorage.setItem('inchheadermenu', JSON.stringify(newarr))
              callBack(newarr)
            })

          })
        }

      })
    },
    getSecMenu (selfmenu, headmenu) {
      var that = this
      var arr = []
      headmenu.map(function (val, index) {
        selfmenu.map(function (va, inde) {
          if (val['id'] == va['parentId']) {
            arr.push(va)
          }
        })
      })

      return arr
    },
    getThirdMenu (selfmenu, headmenu) {

      headmenu.map(function (vals, index) {
        vals['children'] = []
        selfmenu.map(function (vad, inde) {
          if (vals['id'] == vad['parentId']) {
            vals['children'].push(vad)
          }
        })
      })
      return headmenu
    },
    checkVal () {
      if (this.username == '') {
        this.userempty = 1
        // this.$Message.warning('请填写用户名')
        return false
      } else {
        this.userempty = 0
      }
      if (this.password == '') {
        this.passempty = 1
        // this.$Message.warning('请填写密码')
        return false
      } else {
        this.userempty = 0
      }
      // if (!this.inwhiteip) {
      //   if (this.phonecode == '') {
      //     this.codeempty = 1

      //     return false
      //   } else {
      //     this.codeempty = 0
      //   }
      // }

      return true
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!');
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    reloadLocal () {
      localStorage.setItem('schoolTree', null)
      localStorage.setItem('inch_roleData', null)
      localStorage.setItem('inch_partData', null)
      localStorage.setItem('inch_lcdData', null)
      localStorage.setItem('inch_signData', null)
      localStorage.setItem('inch_teachData', null)
      localStorage.setItem('inch_appcenterData', null)
      localStorage.setItem('inch_appnavData', null)
      localStorage.setItem('loadingMenu', null) //应用中心菜单
      localStorage.setItem('inchcurTab', 0)
      localStorage.setItem('inchleftcurIndex', 0)
      localStorage.setItem('inchHeadAct', 0)
    },
    GetRequest () {
      var url = location.search; //获取url中"?"符后的字串
      var strs = ''
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    }
  }
}
</script>

<style scoped>
* {
  margin: 0px;
  padding: 0px;
}

.info {
  text-align: center;

  font-weight: 400;
  font-size: 14px;
  color: #9DA5AD;
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 40px;
}

#loginPage .icon {
  width: auto;
  height: 36px;
  display: block;
  margin-top: 37px;
}

#loginPage header {
  max-width: 1080px;
  height: 90px;
  line-height: 125px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

#loginPage ul {
  display: flex;
  justify-content: space-between;
  width: 42%;
}

.bgImg {
  width: 100%;
  height: auto;
}

.loginbtn {

  background-color: #E22A1C;
  border-color: #E22A1C;
  box-shadow: 0px 2px 10px 0px rgba(226, 42, 28, .2) !important;
}

.bgSection {
  position: relative;
}

.loginYellow {
  cursor: pointer;
  width: 130px;
  height: 40px;
  background-image: linear-gradient(270deg, #FFA939 0%, #FF9228 100%);
  border-radius: 20px;
  position: absolute;
  left: 52%;
  top: 70%;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  letter-spacing: 0.5px;
}

>>>.ivu-checkbox-checked .ivu-checkbox-inner {

  border-color: #E22A1C !important;
  background-color: #E22A1C !important;
}

>>>.ivu-checkbox-focus {
  -webkit-box-shadow: 0 0 0 2px rgba(226, 42, 28, .1);
  box-shadow: 0 0 0 2px rgba(226, 42, 28, .1);

}

#loginPage ul li {
  list-style: none;
  cursor: pointer;
}

.rightCon.act {
  display: block;
}

.rightCon div {
  margin-top: 30px;
  margin-bottom: 20px;
}

.modalCon {
  padding: 30px 40px !important;
}

.rightCon {
  display: none;

  /* width: 60%;
		margin: 80px auto; */
}

.rightCon h2 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 24px;
  color: #1B1F26;
}

.code h2 {
  font-size: 24px;
  color: #1B1F26;
  margin-bottom: 65px
}

.rightCon label {
  font-size: 12px;
  color: #333;
}

.rightCon .password {
  display: flex;
  justify-content: space-between;
}

.rightCon label span {
  color: #aeb1b8;
  font-size: 10px
}

.ivu-btn {
  margin-top: 45px;
  box-shadow: 0px 2px 10px 0px rgb(229, 229, 229);
  height: 40px;
  line-height: 40px;
}

.ivu-btn:last-of-type {
  margin-top: 30px;
}

.loginbtn {
  margin-top: 45px !important;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
  font-size: 12px;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
  font-size: 12px;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
  font-size: 12px;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999;
  font-size: 12px;
}

.ivu-btn-primary {
  box-shadow: 0px 2px 10px 0px rgba(45, 140, 240, .5);
}

.rightCon input {
  font-size: 16px;
  display: block;
  margin-top: 10px;
  padding: 5px 10px;
  border: 0 none;
  border: 1px solid #e0e2e5;
  border-radius: 5px;
  width: 100%;
  outline: 0 none;
}

.rightCon input.active {
  border-bottom: 1px solid #ed4014;
}

#remember {
  font-size: 12px;
}

#qrcode {
  width: 160px;
  height: 160px;
  margin: 0px auto 0px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 0px rgb(229, 229, 229);
  position: relative;
}

#qrcode .delay {
  background: rgba(255, 255, 255, .7);
  width: 160px;
  height: 160px;
  position: absolute;
  left: 0px;
  top: 0px;
  margin: 0px !important;
}

#qrcode .delay span {
  text-align: center;
  width: 70%;
  height: 30px;
  line-height: 30px;
  margin: 65px auto;
  background: #008ee8;
  display: block;
  color: #fff;
  cursor: pointer;
  border-radius: 2px;
}

#QRCode_header {
  margin: 0 auto;
  display: block;
}

.codeText {
  text-align: center;
  font-size: 12px;
  margin-top: 30px;
}

.item {
  position: relative;
}

.item .error {
  font-size: 12px;
  color: #ed4014;
  position: absolute;
  bottom: -20px;
  left: 10px;
}

.password span {
  cursor: pointer;
}

.item .btncon {
  position: relative;
  margin: 0px;
}

.btncode {
  position: absolute !important;
  right: 0px;
  bottom: 0px;
  width: 90px;
  height: 35px;
  line-height: 35px;
}

.btncode.ivu-btn {
  margin-top: 0px;
}
</style>
